import { CSSProperties } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Text } from '@shared/components/Text';
import { AddressField } from '@shared/data/entity/fields/AddressField';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: AddressField;
  style: StyleProp<ViewStyle>;
  textStyle?: CSSProperties;
}

const addressStyles: StyleProp<ViewStyle> = {
  paddingVertical: grid(1),
};

export function AddressCollectionViewField({ field, style, textStyle }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={[addressStyles, style]}>
      <Text size="body1" style={textStyle}>
        {field.address.title}
      </Text>
      <Text size="body1" inactive style={textStyle}>
        {field.address.subtitle}
      </Text>
    </CardCollectionViewFieldContainer>
  );
}
